import { errorTypes } from '~/components';

export const config = {
  selectPartnersNotFoundError: errorTypes.BEAUTY_TO_BEAUTY_SOCIETY_PARTNERS_NOT_FOUND,
};
